module.exports = __webpack_public_path__ + "static/media/fenero.87edd44c.png";